import { useState} from "react";
import { fetchMonthlyRevenueSingleUser, fetchMonthlyStatsAllUsers, fetchWeeklyRevenueAllUsers, exportToTelegram } from "../api/records";
import { useQuery } from "@tanstack/react-query";
import ReportListFilters from "../components/ReportListFilters";
import { GoDownload, GoPerson } from "react-icons/go";
import { IoDocumentTextOutline, IoCalendarClearOutline, IoStatsChart, IoClose } from "react-icons/io5";

 const Reports = () => {
    const [filterAll, setFilterMonthlyReportAll] = useState('this_month');
    const [filterSingle, setFilterMonthlyReportSingle] = useState('this_month');
    const [sheetOpen, setSheetOpen] = useState(false);
    const [sheetMode, setSheetMode] = useState(null);
    const [showAll, setShowAll] = useState(false);
    const INITIAL_ROWS = 10;
    
    const [filterAllDateFrom, setFilterAllDateFrom] = useState("");
    const [filterAllDateTo, setFilterAllDateTo] = useState("");
    const [filterSingleDateFrom, setFilterSingleDateFrom] = useState("");
    const [filterSingleDateTo, setFilterSingleDateTo] = useState("");
    const {data: monthly_stats_data_all = []} = useQuery({
            queryKey: ['monthly-revenue-all-users'],
            queryFn: fetchMonthlyStatsAllUsers
    });
    const {data: weekly_stats_data_all = []} = useQuery({
            queryKey: ['weekly-revenue-all-users'],
            queryFn: fetchWeeklyRevenueAllUsers
    });
    const [currentUserId, setUserId] = useState(null);
    const {data: monthly_data_single = []} = useQuery({
            queryKey: ['monthly-revenue-single-user', { currentUserId, filterSingle, filterSingleDateFrom, filterSingleDateTo }],
            queryFn: () => fetchMonthlyRevenueSingleUser({ currentUserId, filterSingle, filterSingleDateFrom, filterSingleDateTo }),
            enabled: !!currentUserId && (filterSingle !== 'custom' || (!!filterSingleDateFrom && !!filterSingleDateTo))
    });
    const visibleRows = showAll ? monthly_data_single : monthly_data_single.slice(0, INITIAL_ROWS);
    const totalEarnedSingle = monthly_data_single.reduce((sum, row) => sum + row.price, 0);
    const avgEarnedSingle = monthly_data_single.length > 0 ? totalEarnedSingle / monthly_data_single.length : 0;
    
    const clearDates = (e) => {
        if (sheetMode === 'filterAll') {
            setFilterAllDateFrom('');
            setFilterAllDateTo('');
        } else {
            setFilterSingleDateFrom('');
            setFilterSingleDateTo('');
        }};

    const sendToTelegram = ( params ) => {
        exportToTelegram(params)};

    return(
        <div className="flex flex-col w-full max-w-md mx-auto px-3 pt-4 pb-24">
            <h1 className="text-white text-3xl font-bold mb-4">Reports</h1>
            <p className="text-primary-10 text-xs font-mono mt-2 mb-3">GENERAL</p>
                {/* WEEKLY REPORT */}
                <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-3">
                    <div className="flex mb-4 items-center">
                        <div className="rounded-xl p-2 text-2xl bg-warning-50 text-warning-800">
                            <IoCalendarClearOutline />
                        </div>
                        <div className="ml-2">
                            <h3 className="text-white ">
                            Weekly Stats - All Users
                            </h3>
                            <p className="text-primary-10 text-xs">Overview table for current week</p>
                        </div>
                    </div>
                    <table className="w-full text-left mt-4 border-spacing-y-4">
                        <thead className="">
                            <tr className="text-primary-10 text-xs border-b border-separate border-primary-50">
                                <th>MEMBER</th>
                                <th>HOUSES</th>
                                <th>TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {weekly_stats_data_all.map((row, index) => (
                                <tr key={index} className="font-mono text-base">
                                    <td className="text-white">{row.name}</td>
                                    <td className="text-secondary-800">{row.total_houses}</td>
                                    <td className="text-success-800">${row.total_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* MONTHLY STATS ALL USERS */}
                <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-4">
                    <div className="flex mb-4 items-center">
                        <div className="rounded-xl p-2 text-2xl bg-purple-50 text-purple-800">
                            <IoStatsChart />
                        </div>
                    <div className="ml-2">
                        <h3 className="text-white">
                            Monthly Stats - All Users
                        </h3>
                        <p className="text-primary-10 text-xs">Overview table for current month</p>
                    </div>
                    
                    </div>
                    
                    <table className="w-full text-left mt-4 border-spacing-y-4">
                        <thead className="">
                            <tr className="text-primary-10 text-xs border-b border-separate border-primary-50">
                                <th>MEMBER</th>
                                <th>HOUSES</th>
                                <th>TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {monthly_stats_data_all.map((row, index) => (
                                <tr key={index} className="font-mono text-base">
                                    <td className="text-white">{row.name}</td>
                                    <td className="text-secondary-800">{row.total_houses}</td>
                                    <td className="text-success-800">${row.total_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* MONTHLY REPORT ALL */}
                <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-3">
                    <div className="flex mb-4 items-center">
                        <div className="rounded-xl p-2 text-2xl bg-secondary-50 text-secondary-800">
                            <IoDocumentTextOutline />
                        </div>
                        <div className="ml-2">
                            <h3 className="text-white ">
                            Monthly Report
                            </h3>
                            <p className="text-primary-10 text-xs">Full export as Excel into Telegram</p>
                        </div>
                        
                    </div>
                    <div className="flex gap-2 mb-3">
                        <button className={filterAll === 'this_month' ? "flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono" : "flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono"}
                        onClick={() => setFilterMonthlyReportAll('this_month')}>
                            THIS MONTH
                        </button>
                        <button className={filterAll === 'last_month' ? "flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono" : "flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono"}
                        onClick={() => setFilterMonthlyReportAll('last_month')}>
                            LAST MONTH
                        </button>
                        <button className={filterAll === 'custom' ? "flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono" : "flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono"}
                        onClick={() => {setFilterMonthlyReportAll('custom'); setSheetOpen(true); setSheetMode('filterAll');}}>
                            CUSTOM
                        </button>
                    </div>
                    {filterAll === 'custom' && (filterAllDateFrom || filterAllDateTo) && (
                        <div className="flex items-center justify-between bg-background-600 border border-secondary-800 rounded-xl px-3 py-2 mb-3">
                            <p className="text-secondary-800 text-xs font-mono">{filterAllDateFrom} - {filterAllDateTo}</p>
                            <button onClick={() => {
                                setFilterAllDateFrom(''); setFilterAllDateTo(''); setFilterMonthlyReportAll('this_month');
                            }}><IoClose className="text-primary-50 text-sm"/></button>
                        </div>
                    )}
                    <button className="flex w-full items-center justify-center rounded-xl bg-secondary-800 text-white text-sm font-bold mt-3 py-3"
                    onClick={() => sendToTelegram({reportType: 'monthly_report_all', filter: filterAll, dateFrom: filterAllDateFrom, dateTo: filterAllDateTo})}>
                        <GoDownload /> SEND TO TELEGRAM
                    </button>
                </div>
                {/* MONTHLY REPORT PER USER */}
                <p className="text-primary-10 text-xs font-mono mt-2 mb-3">PER WORKER</p>
                <div className="flex gap-2 mb-1">
                    <div className="rounded-xl p-2 text-2xl bg-success-50 text-success-800">
                        <GoPerson />
                    </div>
                    <ReportListFilters onChange={(filters) => {
                        setUserId(filters.worker);
                    }}/>
                </div>
                <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-3">
                    <div className="flex mb-4 items-center">
                        <div className="rounded-xl p-2 text-2xl bg-success-50 text-success-800">
                            <IoDocumentTextOutline />
                        </div>
                        <div className="ml-2">
                            <h3 className="text-white ">
                            Monthly Report
                            </h3>
                            <p className="text-primary-10 text-xs">Full month data for selected worker</p>
                        </div>
                    </div>
                    <div className="flex gap-2 mb-3">
                        <button className={filterSingle === 'this_month' ? "flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono" : "flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono"}
                        onClick={() => setFilterMonthlyReportSingle('this_month')}>
                            THIS MONTH
                        </button>
                        <button className={filterSingle === 'last_month' ? "flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono" : "flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono"}
                        onClick={() => setFilterMonthlyReportSingle('last_month')}>
                            LAST MONTH
                        </button>
                        <button className={filterSingle === 'custom' ? "flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono" : "flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono"}
                        onClick={() => {setFilterMonthlyReportSingle('custom'); setSheetOpen(true); setSheetMode('filterSingle');}}>
                            CUSTOM
                        </button>
                    </div>
                    {filterSingle === 'custom' && (filterSingleDateFrom || filterSingleDateTo) && (
                        <div className="flex items-center justify-between bg-background-600 border border-secondary-800 rounded-xl px-3 py-2 mb-3">
                            <p className="text-secondary-800 text-xs font-mono">{filterSingleDateFrom} - {filterSingleDateTo}</p>
                            <button onClick={() => {
                                setFilterSingleDateFrom(''); setFilterSingleDateTo(''); setFilterMonthlyReportSingle('this_month');
                            }}><IoClose className="text-primary-50 text-sm"/></button>
                        </div>
                    )}
                    <div className="flex items-center gap-2">
                        <div className="w-full bg-background-600 rounded-2xl border border-primary-50 p-2">
                            <p className="text-primary-10 text-xs">HOUSES</p>
                            <p className="text-secondary-800 text-base font-bold">{monthly_data_single.length}</p>
                        </div>
                        <div className="w-full bg-background-600 rounded-2xl border border-primary-50 p-2">
                            <p className="text-primary-10 text-xs">TOTAL</p>
                            <p className="text-success-800 text-base font-bold">${totalEarnedSingle.toFixed(1)}</p>
                        </div>
                        <div className="w-full bg-background-600 rounded-2xl border border-primary-50 p-2">
                            <p className="text-primary-10 text-xs">AVG PRICE</p>
                            <p className="text-white text-base font-bold">${avgEarnedSingle.toFixed(2)}</p>
                        </div>
                    </div>
                    {!currentUserId ? (
                            <p className="text-primary-10 text-base text-center mt-4">Select a worker to see their report</p>
                        ) : (
                            <table className="w-full text-left mt-4 border-spacing-y-4">
                                <thead className="">
                                    <tr className="text-primary-10 text-xs border-b border-separate border-primary-50">
                                        <th>DATE</th>
                                        <th>HOUSE</th>
                                        <th>PRICE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleRows.map((row, index) => (
                                        <tr key={index} className="font-mono text-base">
                                            <td className="text-primary-10">{row.date}</td>
                                            <td className="text-primary-10">{row.house}</td>
                                            <td className="text-success-800">${row.price}</td>
                                        </tr>
                                    ))}
                                    {monthly_data_single.length > INITIAL_ROWS && (
                                        <button 
                                            onClick={() => setShowAll(!showAll)}
                                            className="w-full text-center text-primary-50 text-xs font-mono mt-3 py-2 border border-primary-50 rounded-xl">
                                                {showAll ? 'SHOW LESS' : `SHOW MORE (${monthly_data_single.length - INITIAL_ROWS} remaining)`}
                                            </button>
                                    )}
                                </tbody>
                            </table>
                        )}
                    <button className="flex w-full items-center justify-center rounded-xl bg-success-50 text-success-800 text-sm font-bold border border-success-800 mt-3 py-3"
                    onClick={() => sendToTelegram({reportType: 'monthly_report_single', filter: filterSingle, userId: currentUserId, dateFrom: filterSingleDateFrom, dateTo: filterSingleDateTo})}>
                        <GoDownload /> EXPORT TO TELEGRAM
                    </button>
                </div>
            {sheetOpen && (
                <div className="fixed inset-0 z-50 bg-black/60"
                onClick={() => setSheetOpen(false)}>
                    <div className="absolute bottom-0 left-0 right-0 bg-background-800 rounded-t-2xl p-4"
                        onClick={e => e.stopPropagation()}>
                        <h3 className="text-white text-base mb-2">Custom Range</h3>
                        <p className="text-primary-50 text-xs mb-4">PICK START AND END DATE</p>
                        <div className="grid grid-cols-2 gap-2 mb-5 px-4 overflow-hidden">
                            <div className="min-w-0">
                                    <label className="block text-xs text-primary-50 font-mono mb-1.5">FROM</label>
                                    <input type="date" value={sheetMode === 'filterAll' ? filterAllDateFrom : filterSingleDateFrom}
                                    onChange={e => sheetMode === 'filterAll' ? setFilterAllDateFrom(e.target.value) : setFilterSingleDateFrom(e.target.value)}
                                    max={sheetMode === 'filterAll' ? filterAllDateTo : filterSingleDateTo}
                                    style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                                    className="block bg-background-600 text-white border border-primary-50 rounded-xl px-2 py-2.5 text-sm
                                    focus:outline-none focus:border-secondary-800"/>
                            </div>
                            <div className="min-w-0 pr-2">
                                    <label className="block text-xs text-primary-50 font-mono mb-1.5">TO</label>
                                    <input type="date" value={sheetMode === 'filterAll' ? filterAllDateTo : filterSingleDateTo}
                                    onChange={e => sheetMode === 'filterAll' ? setFilterAllDateTo(e.target.value) : setFilterSingleDateTo(e.target.value)}
                                    min={sheetMode === 'filterAll' ? filterAllDateFrom : filterSingleDateFrom}
                                    style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                                    className="block bg-background-600 text-white border border-primary-50 rounded-xl px-2 py-2.5 text-sm
                                    focus:outline-none focus:border-secondary-800"/>
                            </div>
                        </div>
                        <div className="flex gap-3 px-5">
                            <button onClick={clearDates}
                                    className="flex-1 bg-primary-800 text-primary-50 rounded-xl py-3 text-xs font-mono">
                                    CLEAR
                            </button>
                            <button onClick={() => setSheetOpen(false)}
                                    className="flex-1 bg-secondary-800 text-white rounded-xl py-3 text-xs font-mono font-bold">
                                    APPLY RANGE
                            </button>
                        </div>
                    </div>
                </div>)}
        </div>
    )
}

export default Reports;